import { render, staticRenderFns } from "./XDrugCollection.vue?vue&type=template&id=c6b7a042&scoped=true"
import script from "./XDrugCollection.vue?vue&type=script&lang=js"
export * from "./XDrugCollection.vue?vue&type=script&lang=js"
import style0 from "./XDrugCollection.vue?vue&type=style&index=0&id=c6b7a042&prod&scoped=true&lang=css"
import style1 from "./XDrugCollection.vue?vue&type=style&index=1&id=c6b7a042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b7a042",
  null
  
)

export default component.exports